/*
* @Author: Alex Dong
* @Date:   2020-07-29 13:21:07
 * @Last Modified by: Alex Dong
 * @Last Modified time: 2022-07-30 17:56:37
*/

(function ($) {
	"use strict";
	/* 2026-11-01 PERF (INP): Slick startet nicht mehr fuer alle Karussells gleichzeitig (blockierte das Handy beim Laden
	   mehrere Sekunden). Jedes Karussell startet einzeln in einer eigenen Aufgabe: zuerst die sichtbaren bzw. bald sichtbaren
	   (700 px Vorlauf), die uebrigen in Ruhepausen; bei Beruehrung/Fokus sofort. Vor dem Start zeigt das CSS bereits die
	   fertige einzeilige Kartenreihe. Theme-Editor: wie bisher sofort. */
	var mpbSched = (function () {
		var list = [], io = null, pumpT = 0, idleOn = false, loaded = document.readyState === 'complete';
		var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 250); };
		function near(n) {
			var r = n.getBoundingClientRect();
			return (r.width || r.height) && r.top < (window.innerHeight || 800) + 700 && r.bottom > -700;
		}
		function run(n) {
			var i = list.indexOf(n);
			if (i >= 0) list.splice(i, 1);
			if (io) io.unobserve(n);
			var f = n.__mpbPending;
			if (f) f();
		}
		function pump() {
			pumpT = 0;
			for (var i = 0; i < list.length; i++) {
				if (near(list[i])) { run(list[i]); break; }
			}
			if (list.some(near)) pumpT = setTimeout(pump, 0);
		}
		function schedule() { if (!pumpT) pumpT = setTimeout(pump, 0); }
		function idle() {
			if (idleOn || !loaded) return;
			idleOn = true;
			(function next() {
				if (!list.length) { idleOn = false; return; }
				ric(function () { if (list.length) run(list[0]); next(); }, { timeout: 3000 });
			})();
		}
		if (!loaded) window.addEventListener('load', function () { loaded = true; setTimeout(idle, 300); });
		return {
			add: function (n) {
				if (list.indexOf(n) >= 0) return;
				list.push(n);
				if ('IntersectionObserver' in window) {
					if (!io) io = new IntersectionObserver(function (es) {
						if (es.some(function (e) { return e.isIntersecting; })) schedule();
					}, { rootMargin: '700px 0px' });
					io.observe(n);
				}
				var now = function () { run(n); };
				['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach(function (t) {
					n.addEventListener(t, now, { once: true, passive: true, capture: true });
				});
				schedule();
				if (loaded) idle();
			}
		};
	})();
	/* contentUpdated nach jedem Slick-Start: gebuendelt nur einmal je Durchlauf statt einmal je Karussell */
	var mpbCU = function () {
		if (mpbCU.t) return;
		mpbCU.t = setTimeout(function () { mpbCU.t = 0; $('body').trigger('contentUpdated'); }, 0);
	};
	$.gridSlider = function (element, options) {
		var _ = this,
			defaults = {
				selector: '.grid-slider',
				IntersectionObserver: false
			},
			$element = $(element);
		_.settings = {};
		_.init = function () {
			_.settings = $.extend({}, defaults, options);
			_._initSlider();
		}
		_.uniqid = function (length) {
			length = length || 10;
			var result = '',
				characters = 'abcdefghijklmnopqrstuvwxyz0123456789',
				charactersLength = characters.length;
			for (var i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		};
		_._initSlider = function () {
			var settings = _.settings,
				useIntersectionObserver = settings.IntersectionObserver,
				$head = $('head'),
				elements = $element.find(settings.selector);
			if (!elements.length) elements = $element;
			elements.each(function () {
				var element = $(this),
					isRTL = $('body').hasClass('rtl'),
					selector = 'grid-slider-' + _.uniqid();
				var styleId = selector;
				element.addClass(selector);
				selector = '.' + selector;
				if (isRTL) {
					element.attr('dir', 'rtl');
					element.data('rtl', true);
				}
				if (iClass === undefined) {
					var azInit = element.find('> .slick-list > .slick-track');
					if (azInit.length) {
						azInit.children().addClass('alo-item');
					} else {
						element.children().addClass('alo-item');
					}
					var iClass = '.alo-item';
				}
				var options = element.data(),
					rows = ((options || {}).rows === void 0) ? 1 : options.rows,
					classes = rows ? selector + ' ' + iClass : selector + ' .slick-track > ' + iClass,
					padding = ((options || {}).padding === void 0) ? 0 : options.padding,
					style = classes + '{padding: 0 ' + padding + 'px; box-sizing: border-box} ' + selector + '{margin: 0 -' + padding + 'px; }' + selector + '.grid-init{visibility: visible; opacity: 1;}';
				style += classes + '{float: left; min-height: 1px; min-width: 1px;}';
				style += '.rtl ' + classes + '{float: right; min-height: 1px; min-width: 1px;}';
				if (style) $head.append('<style type="text/css" >' + style + '</style>');
				style = '';
				if (options.slidesToShow) {
					if ("IntersectionObserver" in window && useIntersectionObserver) {
						var nthChild = options.slidesToShow + 1;
						style += selector + ' .item:nth-child(n+ ' + nthChild + ')' + '{display: none;} ' + selector + ' .item{float:left};';
						var gridSliderObserver = new IntersectionObserver(function (entries, observer) {
							entries.forEach(function (entry) {
								if (entry.isIntersecting) {
									var el = entry.target;
									var $el = $(el);
									$el.on('init', function () {
										$head.find('#' + styleId).remove();
									});
									_.sliderRender($el);
									/* gridSliderObserver.unobserve(el); */
								}
							});
						}, { root: null, rootMargin: '10px', threshold: 0.5 });
						element.each(function (index, el) {
							var $el = $(el);
							if ($el.is(':visible')) {
								gridSliderObserver.observe(el);
							} else {
								_.sliderRender($el);
							}
						});
					} else {
						_.deferRender(element);
					}
				}
				if (options.appendArrows || options.appendDots) {
					var wrapper = options.wrapper ? element.find(options.wrapper) : element.parent();
					if (options.appendArrows) element.data('append-Arrows', wrapper.find(options.appendArrows));
					if (options.appendDots) element.data('append-Dots', wrapper.find(options.appendDots));
				}
				var responsive = _.getPesponsive(options);
				if (responsive == undefined) return;
				var length = Object.keys(responsive).length;
				$.each(responsive, function (key, value) {
					var col = 0, maxWith = 0, minWith = 0;
					$.each(value, function (size, num) { minWith = parseInt(size) + 1; col = num; });
					if (key + 2 < length) {
						$.each(responsive[key + 1], function (size, num) { maxWith = size; col = num; });
						style += ' @media (min-width: ' + minWith + 'px) and (max-width: ' + maxWith + 'px)';
					} else {
						if (key + 2 == length) return; // don't use key = length - 1;
						$.each(responsive[key], function (size, num) { maxWith = size; col = num; });
						style += ' @media (min-width: ' + maxWith + 'px)';
					}
					var clearRtl = (rows != 1) ? classes + ':nth-child(' + col + 'n+1){clear: left}' : ' ';
					clearRtl += (rows != 1) ? '.rtl ' + classes + ':nth-child(' + col + 'n+1){clear: right}' : ' ';
					style += ' {' + selector + '{margin: 0 -' + padding + 'px}' + classes + '{padding: 0 ' + padding + 'px; box-sizing: border-box; width: calc(100% / ' + col + ')} ' + clearRtl + '}';
				});
				$head.append('<style type="text/css" id="' + styleId + '" >' + style + '</style>');
				element.addClass('grid-init');
			});
			return this;
		};
		_.getPesponsive = function (options) {
			if (!options.responsive) return;
			if (!options.slidesToShow) return options.responsive.reverse();
			var responsive = options.responsive,
				length = Object.keys(responsive).length,
				gridResponsive = [];
			$.each(responsive, function (key, value) {
				var breakpoint = {};
				breakpoint[value.breakpoint] = parseInt(value.settings.slidesToShow);
				gridResponsive.push(breakpoint);
			});
			return gridResponsive.reverse();
		};
		_.deferRender = function (el) {
			var n = el[0];
			if (!n || (window.Shopify && Shopify.designMode)) { _.sliderRender(el); return; }
			if (n.__mpbPending || el.hasClass('slick-initialized')) return;
			n.__mpbPending = function () { n.__mpbPending = null; _.sliderRender(el); };
			mpbSched.add(n);
		};
		_.sliderRender = function (el) {
			if (el.hasClass('slick-initialized')) {
				el.slick("refresh");
				return;
			}
			var options = el.data(),
				lazy = el.find('img.lazyload');
			if (lazy.length) {
				lazy.each(function (index) {
					$(this).data('lazy', $(this).data('src'));
				});
			}
			el.on('init', function (event, slick) {
				mpbCU(); // support lazyload (gebuendelt)
				var video = $(this).find('.external-video'),
					slide = slick.$slides.get(0);
				video.on('click', function (e) {
					e.preventDefault();
					if ($this.hasClass('embed')) return;
					var $this = $(this), img = $this.find('img'), url = $(this).data('video');
					url = url.replace("://vimeo.com/", "://player.vimeo.com/video/");
					url = url.replace("://www.youtube.com/watch?v=", "://youtube.com/embed/");
					url = url + '?autoplay=1&badge=0';
					var iframe = '<iframe class="iframe-video" src="' + url + '" width="' + img.width() + '" height="' + img.height() + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
					$this.append(iframe).addClass('embed');
					img.hide();
				});
				_.playVideo(slide);
			});
			/* 2026-10-30 PERF: Autoplay erst ab der ersten Besucher-Aktion (window.mpbFirstInput, layout/theme.liquid) */
			/* 2026-11-02: Autoplay haelt nicht mehr an, nur weil die Maus beim Scrollen ueber dem Slider steht. Beim ersten Sichtbarwerden sofort ein Schritt. */
			if (options.autoplay) {
				options = $.extend({}, options, { pauseOnHover: false });
				if ('IntersectionObserver' in window && window.mpbFirstInput) {
					var stepIo = new IntersectionObserver(function (es) {
						if (!es[0].isIntersecting) return;
						stepIo.disconnect();
						window.mpbFirstInput(function () {
							if (el.hasClass('slick-initialized')) el.slick('slickNext');
						});
					}, { threshold: 0.35 });
					stepIo.observe(el[0]);
				}
			}
			if (options.autoplay && window.mpbFirstInput && !window.mpbFirstInput.done) {
				options = $.extend({}, options, { autoplay: false });
				window.mpbFirstInput(function () {
					if (!el.hasClass('slick-initialized')) return;
					el.slick('slickSetOption', 'autoplay', true, false);
					if (el[0].__mpbVis !== false) el.slick('slickPlay');
				});
			}
			var slider = el.slick(options);
			el.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				var video = $(this).find('.external-video'),
					nextSlide = slick.$slides.get(nextSlide);
				video.removeClass('embed').find('img').show();
				video.find('.iframe-video').remove();
				_.playVideo(nextSlide);
			});
			slider.on("click", ".item", function () {
				el.slick('slickSetOption', "autoplay", false, false);
			});
		};
		_.playVideo = function (slide) {
			var $slide = $(slide),
				video = $slide.find('video').not('.init'),
				videoPlay = $slide.find('.video-play');
			if (video.length && videoPlay.length) {
				video.addClass('init');
				video = video.get(0);
				videoPlay.on('click', '.btn-play', function () {
					if (video.paused) {
						video.play();
					} else {
						video.pause();
					}
					videoPlay.toggleClass('pause');
				});
			}
		}
		_.init();
	}
	$.fn.gridSlider = function (options) {
		return this.each(function () {
			if (undefined == $(this).data('gridSlider')) {
				var plugin = new $.gridSlider(this, options);
				$(this).data('gridSlider', plugin);
			}
		});
	}
	/* 2026-11-02: Produkte erscheinen auch am Handy sofort, nicht erst nach der ersten Beruehrung. Das Autoplay startet weiter mit der ersten Besucher-Aktion (mpbFirstInput). */
	$(function () {
		$(".grid-slider").not('grid-slider, .exception').each(function () {
			$(this).gridSlider();
		});
	});
	$(document).on('contentUpdated', function (event) {
		$(".grid-slider").not('grid-slider, .exception, .grid-init, .slick-initialized').each(function () {
			$(this).gridSlider();
		});
	});
	$(document).on('Alothemes:SwitchRTL:reload', function (event) {
		$(".grid-slider").not('grid-slider, .exception').each(function () {
			if ($('body').hasClass('rtl')) {
				$(this).attr('dir', 'rtl').data('rtl', true);
			} else {
				$(this).attr('dir', 'ltr').data('rtl', false);
			}
			if ($(this).hasClass('slick-initialized')) {
				$(this).slick("unslick").slick($(this).data());
			}
		});
	});
	$(document).on('shopify:section:unload shopify:section:load', function (event) {
		$('#shopify-section-' + event.detail.sectionId).find(".grid-slider").not('grid-slider, .exception').each(function () {
			$(this).gridSlider();
		});
	});

	if (!customElements.get('grid-slider')) {
		class GridSlider extends HTMLElement {
			constructor() {
				super();
				var $this = this;
				document.addEventListener("GridSliderUpdated", function (event) {
					$this.initialized();
				});
			}

			connectedCallback() {
				if (this.slick) {
					$(this).slick("refresh")
				} else {
					if (!this.classList.contains('ajax')) this.initialized();
				}
			}

			initialized() {
				$(this).not(".exception, .grid-init, .slick-initialized").each(function () {
					$(this).gridSlider();
				});
			}

		}
		customElements.define("grid-slider", GridSlider);
	}
})(window.$$ || jQuery);
